import { Stack } from "@volca/ui/components/ui/stack";
import { cn } from "@volca/ui/lib/utils";
import { PAYROLL_PANE_FILL_CLASS_NAME } from "@/payroll/pay-breakdown/payroll-grid-layout";
import { PayrollStatementNotificationsContent } from "@/payroll/pay-breakdown/payroll-statement-notifications/payroll-statement-notifications-page";

// The full statement-emails feature, mounted INLINE (scoped to the current
// period) — the same view the standalone /notifications route renders, minus its
// page chrome. Preview-only tenants receive the same read experience without any
//
// The section's provider is mounted by the page rather than here, because the
// header controls it feeds render above this tab.
export const PayBreakdownEmailsTab = () => (
  <Stack
    gap={0}
    align="stretch"
    className={cn("w-full", PAYROLL_PANE_FILL_CLASS_NAME)}
  >
    <PayrollStatementNotificationsContent embedded />
  </Stack>
);
